import { RabEntry } from "../types";

// Falls-Back-Datenbank mit hochqualitativen, realistischen und gesetzeskonformen RAB 32 Sicherheitsinspektionen
export const UFSA_FALLBACK_CATALOG: Omit<RabEntry, 'id'>[] = [
  {
    component: "Flachdach-Abdichtung & Gullys",
    category: "Dach",
    activity: "Reinigung und Inspektion des Flachdachs sowie aller Gullys und Notüberläufe",
    hazards: "Absturz von der Dachkante, Stolpern über Unebenheiten, Einbruchgefahr bei ungesicherten Lichtkuppeln",
    measures: "Verwendung der fest installierten Anschlageinrichtungen (PSAgA). Lichtkuppeln mit Gittern oder Durchsturzsicherungen versehen. Arbeiten nur bei trockener, windstiller Witterung.",
    frequency: "Halbjährlich (Frühjahr und Herbst)",
    regulations: "DIN 4426, DGUV Regel 112-198, ArbStättV"
  },
  {
    component: "Fassadenbefahrungsanlage / Außenfenster",
    category: "Fassade",
    activity: "Reinigung und Revision der äußeren Verglasungen und Vorhangfassaden im Obergeschoss",
    hazards: "Absturz von Personen bei der Außenreinigung, Herabfallen von schweren Arbeitsmitteln, Windabdrift",
    measures: "Verwendung zugelassener Fassadenbefahranlagen (FBA) oder professioneller Hubarbeitsbühnen. Anschlagpunkte für Sicherheitsgeschirr nutzen. Abgrenzung und Sperrung des darunterliegenden Aufenthaltsbereichs.",
    frequency: "Halbjährlich",
    regulations: "DGUV Information 212-019, TRBS 2121, ArbSchG"
  },
  {
    component: "Blitzschutzanlage",
    category: "Elektro/Dach",
    activity: "Überprüfung der Ableitungen und Durchgängigkeitsmessung der Fangeinrichtungen auf dem Dach",
    hazards: "Absturz von der Dachkante, Blitzschlag bei plötzlichen Gewittern",
    measures: "Zugang nur über fest installierte Treppen/Ausstiege. Einhaltung ausreichender Sicherheitsabstände zur ungestützten Dachkante. Tragbares Messbesteck sturzsicher transportieren.",
    frequency: "Alle 2 bis 4 Jahre (durch Blitzschutzfachkraft)",
    regulations: "DIN EN 62305-3, VDE 0185-305"
  },
  {
    component: "Glasvordach über dem Haupteingang",
    category: "Fassade",
    activity: "Sichtprüfung der Halterungen, Dichtungen und Reinigung der Verglasung",
    hazards: "Bruch der Verglasung bei unsachgemäßem Begehen, Absturz aus der Höhe",
    measures: "Nicht begehbare Verglasung! Reinigung und Arbeiten dürfen ausschließlich über Hubarbeitsbühnen oder standsichere Stehleitern mit Hilfsmitteln durchgeführt werden.",
    frequency: "Jährlich",
    regulations: "DGUV Vorschrift 38, DIN 18008"
  },
  {
    component: "Fassadenbegrünung",
    category: "Fassade",
    activity: "Rückschnitt und Pflege der Kletterpflanzen an der Außenwand",
    hazards: "Absturz von losen Anlegeleitern, Augenverletzungen durch abstehende Äste",
    measures: "Einsatz von standsicheren fahrbaren Arbeitsbühnen (Rollgerüst) statt loser Leitern. Tragen von Schutzbrillen und robusten Schnittschutzhandschuhen.",
    frequency: "Jährlich",
    regulations: "TRBS 2121, DGUV Regel 112-189"
  },
  {
    component: "Schneefanghalterungen und Gitter",
    category: "Dach",
    activity: "Sichtprüfung der Verankerungen auf Lockerung oder Deformationsschäden",
    hazards: "Absturz von Steildächern, Abrutschen auf vereisten Flächen bei Winterprüfungen",
    measures: "Einsatz von temporären Sicherheitsdachhaken. Unterweisung der Mitarbeiter bezüglich Rutsch- und Absturzgefahren. Tragen von PSAgA bei Steildachbegehung.",
    frequency: "Jährlich vor der Winterperiode",
    regulations: "DIN EN 517, DGUV Information 201-054"
  },
  {
    component: "Heizungszentrale / Gastherme",
    category: "Haustechnik",
    activity: "Abgasmessung, Reinigung des Brennraums und Dichtheitsprüfung aller Anschlüsse",
    hazards: "Gasaustritt, Verpuffungsgefahr, CO-Vergiftung, Verbrennungen an heißen Oberflächen",
    measures: "Absperrung der Gaszufuhr vor Wartungen. Installation eines mobilen CO-Warnmelders. Arbeiten dürfen nur von fachlich qualifizierten Heizungsbauern ausgeführt werden.",
    frequency: "Jährlich",
    regulations: "BetrSichV, DVGW-Arbeitsblätter, FeuVO"
  },
  {
    component: "Rauch- und Wärmeabzugsanlage (RWA)",
    category: "Brandschutz",
    activity: "Funktionsprüfung der Druckgasgeneratoren, CO2-Patronen und Pneumatikzylinder",
    hazards: "Absturz an der RWA-Öffnung, Quetschgefahr durch unkontrolliert herabfahrende Klappen",
    measures: "Montage von Schutzgittern um die RWA-Öffnung. Mechanische Verriegelung der Klappe in der Wartungsposition zur Absicherung gegen plötzlichen Druckabfall.",
    frequency: "Jährlich",
    regulations: "DIN 18232, LBO, VdS 2098"
  },
  {
    component: "Zentrallüftungsanlage / Klimatruhe",
    category: "Haustechnik",
    activity: "Filterwechsel und hygienische Keimmessung im Gehäuse",
    hazards: "Einatmen von infektiösen Staubpartikeln, Pilzsporen oder Legionellen beim trockenen Filterwechsel",
    measures: "Hauptschalter an der Elektroanlage sperren. Tragen von partikelfiltrierendem Atemschutz (mind. FFP2/FFP3) und Einweghandschuhen beim Filtertausch.",
    frequency: "Halbjährlich",
    regulations: "VDI 6022, DGUV Regel 109-002, TRBA 120"
  },
  {
    component: "Warmwasser-Zirkulationssystem (Legionellenschutz)",
    category: "Sanitär",
    activity: "Thermische Desinfektion der Trinkwasserleitungen und regelmäßige Probeentnahme",
    hazards: "Schwere Verbrennungen oder Verbrühungen an geöffneten Wasserhähnen während des Heizzyklus (> 70°C)",
    measures: "Durchführung außerhalb der Kernnutzungszeiten. Warnhinweise an allen betroffenen Zapfstellen anbringen. Temperaturüberwachung am Systemausgang.",
    frequency: "Jährlich (oder nach Vorgabe Trinkwasserverordnung)",
    regulations: "TrinkwV, DVGW W 551, DVGW W 553"
  },
  {
    component: "Notstromaggregat (Diesel-Verbrennungsmotor)",
    category: "Haustechnik",
    activity: "Prüfung des Kraftstoffsystems, Ölstands und Testlauf unter Reallast",
    hazards: "Kohlenmonoxidvergiftung durch Abgase, Hörverlust durch Lärmbelastung, rotierende Antriebskomponenten mit Quetschgefahr",
    measures: "Sicherstellen einer direkten, gasdichten Abgasabführung ins Freie. Gehörschutz tragen. Aggregateraum geschlossen halten und Warnbeschilderung beachten.",
    frequency: "Monatlicher Testlauf (gemäß Herstellerspezifikation)",
    regulations: "DGUV Regel 103-009, VDE 0100-718, BetrSichV"
  },
  {
    component: "Abwasser-Hebeanlage und Pumpensumpf",
    category: "Sanitär",
    activity: "Reinigung des Auffangbehälters, Überprüfung der Niveauschalter und Fäkalienpumpen",
    hazards: "Infektionsgefahren durch biologische Stoffe (Fäkalien), Erstickung in engen, unbelüfteten Schächten",
    measures: "Feste persönliche Arbeitshygiene einhalten. Tragen von Schutzhandschuhen und Schutzanzug. Schachtbereich vor dem Einstieg lüften und mit Gaswarngerät freimessen.",
    frequency: "Halbjährlich",
    regulations: "DIN EN 12056-4, BioStoffV, DGUV Regel 113-004"
  },
  {
    component: "Hauptniederspannungsverteiler (NSHV)",
    category: "Elektro",
    activity: "Sichtprüfung der Schaltanlagen, Messung der Schleifenimpedanz und Thermografie der Kontakte",
    hazards: "Gefahr eines elektrischen Schlags (Körperdurchströmung), Verbrennungen durch Lichtbogenbildung bei Kurzschluss",
    measures: "Arbeiten dürfen ausnahmslos durch eine zertifizierte Elektrofachkraft ausgeführt werden. Einhaltung der 5 Sicherheitsregeln. Tragen von PSA gegen Störlichtbögen.",
    frequency: "Alle 4 Jahre",
    regulations: "DGUV Vorschrift 3, DIN VDE 0105-100"
  },
  {
    component: "Sicherheits- und Fluchtwegbeleuchtung",
    category: "Brandschutz",
    activity: "Funktionsprüfung der Notleuchten und Kontrolle der Akkumulatoren auf Nennkapazität",
    hazards: "Sturz von Trittleitern beim Auswechseln von Leuchtmitteln in Fluren",
    measures: "Verwendung von standsicheren Stehleitern mit rutschhemmendem Fuß. Allpoliges Freischalten der Spannungsversorgung vor Arbeiten am Stromkreis.",
    frequency: "Sichtprüfung wöchentlich, Kapazitätsprüfung jährlich",
    regulations: "DIN EN 50172, DIN VDE 0108, ASR A1.3"
  },
  {
    component: "Photovoltaik-Aufdachanlage (Module & Wechselrichter)",
    category: "Elektro/Dach",
    activity: "Sichtprüfung der Dachhaken, Leitungsverlegung und Funktionskontrolle der DC-Stränge",
    hazards: "Absturz von der Dachkante, Lebensgefährliche Berührungsspannung (DC-Spannung steht auch nach Netztrennung an)",
    measures: "Begehung nur über fest verlegte Laufroste. Wartung nur bei Tageslicht ausführen, Isolationsprüfung lückenlos durchführen. Arbeiten nur durch Solar-Fachkraft.",
    frequency: "Jährlich",
    regulations: "DIN VDE 0126-23, DIN VDE 0100-712"
  },
  {
    component: "Verkehrswege und Außenbeleuchtung",
    category: "Elektro",
    activity: "Mastprüfung (Standfestigkeit), Sichtkontrolle der Gehäuse und Leuchtmittelwechsel",
    hazards: "Gefährdung durch den fließenden Verkehr im Zufahrtsbereich, Absturz von der Hubarbeitsbühne",
    measures: "Absperrung des Arbeitsbereichs am Boden mit Kegeln und Warnbeschilderung. Tragen von Warnkleidung (Klasse 3). PSAgA in der Arbeitsbühne anwenden.",
    frequency: "Alle 2 Jahre",
    regulations: "DGUV Regel 114-003, VDE 0105-150"
  },
  {
    component: "Personenaufzug / Lastenaufzug",
    category: "Fördertechnik",
    activity: "Reinigung des Schachtkopfs, Prüfung der Tragseile, Fangvorrichtung und Türsteuerungen",
    hazards: "Absturz in den offenen Aufzugsschacht, Quetschen durch unvorhergesehene Kabinenbewegung",
    measures: "Aufzugsanlage vollständig außer Betrieb nehmen. Zugangstüren zum Schacht mechanisch sichern. Steuerungsverfahren nur auf Revisions- oder Notfahrtbetrieb zulassen.",
    frequency: "Monatlich (Instandhaltung), Prüfung alle 2 Jahre durch ZÜS",
    regulations: "BetrSichV, DIN EN 81"
  },
  {
    component: "Sektionaltore / Tiefgaragentore",
    category: "Fördertechnik",
    activity: "Prüfung der Sicherheitskontaktleisten, Lichtschranken und der mechanischen Absturzsicherung des Torblatts",
    hazards: "Quetschungen von Extremitäten im Schließbereich des Tors, plötzliches Herabstürzen bei Federbruch",
    measures: "Prüfung der Auslösekraft an den Hauptschließkanten. Regelmäßige Sichtprüfung der Torsionsfedern und Tragseile durch Sachkundigen.",
    frequency: "Jährlich",
    regulations: "ASR A1.7, DGUV Regel 108-006"
  },
  {
    component: "Handfeuerlöscher (tragbar & fahrbar)",
    category: "Brandschutz",
    activity: "Prüfung der Treibgaskartusche, des Löschpulvers/CO2 und der Füllmenge",
    hazards: "Verletzungen durch unkontrolliert entweichenden Prüfdruck",
    measures: "Löscher vor dem Öffnen vollständig drucklos machen. Nur für dieses Gerät zugelassene Original-Ersatzteile einsetzen. Wartung nur durch Sachkundigen.",
    frequency: "Alle 2 Jahre",
    regulations: "DIN 14406-4, ASR A2.2, BetrSichV"
  },
  {
    component: "Brandschutz- & Rauchschutztüren (Feststellanlagen)",
    category: "Brandschutz",
    activity: "Überprüfung des freien Türlaufs, der Schließfolgeregler und Funktionsdauer der Feststellanlagen",
    hazards: "Quetschungen von Fingern im Türfalz oder an der Nebenschließkante, Verlust des Raumabschlusses im Brandfall",
    measures: "Kein Festkeilen oder Verstellen von Brandschutztüren im Betrieb gestatten. Magnetkontakte regelmäßig auf Verschmutzungen prüfen.",
    frequency: "Jährlich",
    regulations: "DIBt-Richtlinie, DIN 14677, ASR A1.7"
  },
  {
    component: "Brandschutzklappen (BSK) im Lüftungssystem",
    category: "Brandschutz",
    activity: "Auslösung der Schmelzlote bzw. Stellmotoren und visuelle Endlagenprüfung im Lüftungskanal",
    hazards: "Quetschwunden an Polen und Fingern beim Auslösen der Federrücklaufmotoren über die Revisionsöffnung",
    measures: "Arme und Finger nicht in den unmittelbaren Schwenkbereich des Klappenblatts halten. Zugang nur über trittsichere Podeste sichern.",
    frequency: "Jährlich",
    regulations: "DIN EN 15650, Landes-Lüftungsanlagenrichtlinien (LüAR)"
  },
  {
    component: "Wandhydranten (Steigleitung nass/trocken)",
    category: "Brandschutz",
    activity: "Druck- und Volumenstromprüfung der Löschwasserleitung, Schlauchwartung",
    hazards: "Rutschgefahr durch austretendes Löschwasser auf Verkehrswegen",
    measures: "Sichere Kupplungsverbindungen einsetzen. Druckanstieg langsam regeln zur Vermeidung von Druckstößen. Wasserfangbereiche trockenlegen.",
    frequency: "Jährlich",
    regulations: "DIN 14461-1, DIN EN 671-3"
  },
  {
    component: "Zufahrten, Gehwege und Rampen",
    category: "Außenanlage",
    activity: "Verkehrssicherungsprüfungen, Beseitigung von Stolpersteinen (Setzungen > 2cm), Winterdienst",
    hazards: "Rutsch- und Sturzunfälle von Passanten und Mitarbeitern auf Glatteis oder schadhaften Gehwegen",
    measures: "Lückenlose Dokumentation der Streu- und Räumarbeiten im Winterdiensthandbuch. Sofortiges Absperren tief sitzender Plasterbereiche bis zur dauerhaften Behebung.",
    frequency: "Wöchentlich, im Winter bedarfsgerecht täglich",
    regulations: "BGB § 823 (Verkehrssicherungspflicht)"
  },
  {
    component: "Tiefgaragen-Gaswarnanlage (CO-Detektoren)",
    category: "Haustechnik",
    activity: "Eichung und Kalibrierung der Gassensoren mit Prüfgasgemischem",
    hazards: "Erststickung oder Vergiftung durch Abgaskonzentrationen im Fehlerfall, Stromschlag an den Verteilerboxen",
    measures: "Sensorköpfe nur mit kalibriertem Prüfgas beaufschlagen. Funktion des Lüfteranlaufs bei Erreichen der Alarmschaltschwellen prüfen.",
    frequency: "Halbjährlich",
    regulations: "GarVO der Länder, VDI 2053"
  },
  {
    component: "Rigolen und Regenrückhaltebecken",
    category: "Außenanlage",
    activity: "Entschlammung, Reinigung der Vorschaltfilter und Einlaufbauwerke",
    hazards: "Sauerstoffmangel oder biologisches Gas (H2S-Bildung) beim Einstieg in Filterschächte, Ertrinkungsgefahr",
    measures: "Schachtbereiche vor Begehungen lüften und Sauerstoffgehalt messen. Verwendung eines Sicherheitsgeschirrs mit Dreibock/Rettungswinde über Tage.",
    frequency: "Jährlich",
    regulations: "DGUV Regel 113-004, WHG"
  },
  {
    component: "Baumbestand und Hangsicherungen",
    category: "Außenanlage",
    activity: "Prüfung auf Standfestigkeit, morsche Äste und Rückschnitt im Lichtraumprofil",
    hazards: "Herabfallende Äste auf Gehwege, Umsturz ganzer Bäume bei Sturm, Absturz bei Sägearbeiten",
    measures: "Ausführung von Baumpflegearbeiten nur durch zertifizierte Fachbetriebe. Absperrung des Gefahrenbereichs unterhalb der Baumkrone.",
    frequency: "Halbjährliche Sichtung (belaubt und unbelaubt)",
    regulations: "FLL-Baumpflege-Richtlinien, BGB § 823"
  },
  {
    component: "Bodenbeläge in Fluren und Treppenräumen",
    category: "Innenräume",
    activity: "Messung der Rutschfestigkeit und Sanierung loser Trittkanten oder Fugen",
    hazards: "Sturz- und Stolperunfälle auf wichtigen Flucht- und Rettungswegen",
    measures: "Beschädigte Trittprofile umgehend anschrauben/kleben. Keine rutschigen Reinigungsmittel verwenden. Ausreichende Beleuchtungsstärke sicherstellen.",
    frequency: "Halbjährlich",
    regulations: "ASR A1.8, DGUV Regel 108-003, DIN 18065"
  },
  {
    component: "Gefahrstoffdepot / Auffangwannen",
    category: "Innenräume",
    activity: "Dichtheitsprüfung der metallischen oder PE-Auffangwannen, Wartung der Absaugung",
    hazards: "Hautkontakt mit Säuren/Laugen/Ölen, Einatmen brennbarer oder toxischer Lösemitteldämpfe",
    measures: "Tragen chemikalienbeständiger Schutzkleidung (Schürze, Handschuhe, Augenschutz). Bereitstellung von speziellem Chemikalienbindemittel.",
    frequency: "Monatliche visuelle Kontrolle, jährliche technische Prüfung",
    regulations: "TRGS 510, WHG, AwSV"
  },
  {
    component: "Rettungswegetüren (Panikschlösser)",
    category: "Brandschutz",
    activity: "Prüfung der Gängigkeit der Panikstangen und Antipanikschlösser",
    hazards: "Blockierung der Fluchtwege bei Notfälle durch defekte oder verschlossene Schlösser",
    measures: "Sicherstellen, dass Fluchttüren niemals von innen verriegelt oder mit Keilen verstellt werden. Scharniere und Riegel ölen.",
    frequency: "Tägliche Sichtkontrolle, monatliche Funktionsprüfung",
    regulations: "ASR A2.3, DIN EN 179, DIN EN 1125"
  },
  {
    component: "Fäkalienhebeanlage",
    category: "Sanitär",
    activity: "Funktionsprüfung des Zerkleinerungswerks und Beseitigung von Ablagerungen",
    hazards: "Gefahr von Infektionen und Magen-Darm-Erkrankungen durch Fäkalkontakt, Stromschlag bei Wartungsarbeiten",
    measures: "Allpoliges Freischalten des Steuergeräts. Tragen von reißfesten Nitril-Schutzhandschuhen, Schutzbrille und Einweg-Schutzkleidung.",
    frequency: "Halbjährlich",
    regulations: "DIN EN 12056-4, BioStoffV"
  },
  {
    component: "Oberlichter und Lamellenfenster (elektrisch)",
    category: "Innenräume",
    activity: "Funktionskontrolle der Kettenantriebe und Schmierung der Lager",
    hazards: "Quetschgefahr an den Rahmenkanten bei automatisch gesteuerter Schließung",
    measures: "Wartungsschalter auf 'Handbetrieb' stellen. Während der Arbeiten Kettenantrieb mechanisch arretieren. Trittfeste Gerüste einsetzen.",
    frequency: "Jährlich",
    regulations: "ASR A1.7, TRBS 2121"
  },
  {
    component: "Kellerboxen und Lattenzäune",
    category: "Innenräume",
    activity: "Nachziehen von Holzschrauben und Prüfung der Kantenspaltgatter",
    hazards: "Schnittwunden an abstehenden Splittern, Nägeln, Drähten",
    measures: "Abstehende Befestigungen planschleifen oder versenken. Scharfe Kanten brechen. Tragen von robusten Arbeitshandschuhen.",
    frequency: "Jährlich",
    regulations: "DGUV Vorschrift 1"
  }
];
